/**
 * @typedef {Object} DirectionsRouteInformationsParams
 * DirectionsRouteInformations parameters
 * @property {number} rendererIndex rendererIndex
 * @property {String} travelMode travelMode
 * @property {String} summary summary
 * @property {number} distance distance
 * @property {String} durationLong durationLong
 * @property {number} durationShort durationShort
 * @property {String} durationInTrafficLong durationInTrafficLong
 * @property {number} durationInTrafficShort durationInTrafficShort
 */

/**
 * Class representing relevant informations for a route
 * @private
 */
class DirectionsRouteInformations {
    /**
     * constructor
     * @param {DirectionsRouteInformationsParams} params DirectionsRouteInformations parameters
     */
    constructor(params) {
        this.rendererIndex = params.rendererIndex;
        this.travelMode = params.travelMode;
        this.summary = params.summary;
        this.distance = params.distance;
        this.durationLong = params.durationLong;
        this.durationShort = params.durationShort;
        this.durationInTrafficLong = null;
        this.durationInTrafficShort = null;
    }

    /**
     * Sets long duration in traffic.
     * @param {String} durationInTrafficLong
     */
    setDurationInTrafficLong(durationInTrafficLong) {
        this.durationInTrafficLong = durationInTrafficLong;
    }

    /**
     * Sets short duration in traffic.
     * @param {String} durationInTrafficShort
     */
    setDurationInTrafficShort(durationInTrafficShort) {
        this.durationInTrafficShort = durationInTrafficShort;
    }
}

module.exports = DirectionsRouteInformations;
